"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const AuthErrorSceneTranslation = {
    fi: {
        AuthErrorScene: {
            title: 'Oops... Tapahtui virhe',
            toLogin: 'Kirjautumissivulle',
            subTitle: 'Emme kyenneet löytämään virheen syytä.',
        },
    },
    en: {
        AuthErrorScene: {
            title: 'Oops... There was an error',
            toLogin: 'To login',
            subTitle: "We couldn't find reason for an error.",
        },
    },
};
exports.default = AuthErrorSceneTranslation;
//# sourceMappingURL=AuthErrorScene.translation.js.map